import type { PortalReferral } from '@/services/referralsService'
import { formatCurrency } from '@/utils/format-currency'

export function referralCommissionLabel(row: PortalReferral): string {
  if (row.commission?.valor != null) return formatCurrency(row.commission.valor)
  if (row.comissaoPrevista?.valor != null) {
    const money = formatCurrency(row.comissaoPrevista.valor)
    const amount = row.comissaoPrevista.recorrente ? `${money} / mês` : money
    return `Expectativa se fechar: ${amount}`
  }
  return '—'
}
